<template>
  <div class="iv-main-header">
    <div class="iv-tooltop"></div>
    <div class="iv-header-top iv-main-width">
      <span class="logo"><img src="~@/assets/images/new-home/logo.png" /></span>
      <span class="search">
        <Input type="text" v-model="value" icon="ios-search-strong" placeholder="请输入关键词" @on-enter="toSearch"/>
        <!-- <span class="iv-fs-16 iv-user-info">
          欢迎您：<span class="iv-fw-b">{{ userName }}</span>&nbsp;同志
          <span class="iv-m-l-24 iv-pointer" @click="goUserCenter">
            <IconFont type="account-fill" class="iv-m-r-8" />个人中心
          </span>
          <span class="iv-m-l-24 iv-pointer" @click="login">
            <IconFont type="poweroff" class="iv-m-r-8" />退出系统
          </span>
        </span> -->
        <!-- <Button shape="circle" noIcon @click="login" v-else>登录</Button> -->
      </span>
    </div>
  </div>
</template>
<script>
import IconFont from '@/components/iconfont'
export default {
  components: { IconFont },
  data () {
    return {
      isLogin: false,
      userName: '张三丰',
      value: ''
    }
  },
  created () { 
  },
  methods: {
    login () {
      this.isLogin = !this.isLogin
    },
    goUserCenter () {
      this.$Message.success('建设中！')
    },
    toSearch() {
      this.$router.push({
        name: 'searchPage',
        query: {
          keyword: this.value
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/new-blue/variable.scss';

@media screen and (max-width: 1920px) {
  .iv-tooltop {
    min-width: 1200px !important;
  }
}

.iv-main-header {
  .iv-tooltop {
    width: 100%;
    background-color: $iv-main-color;
    height: 5px;
  }

  .iv-header-top {
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span.logo {
      img {
        height: 40px
      }
    }

    span.search {
      min-width: 438px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .iv-user-info {
        width: 720px;
        text-align: right;
      }

      .ivu-input-wrapper {
        width: calc(100% - 88px);

        /deep/ .ivu-input-icon {
          line-height: 36px !important;
          color: $iv-main-color;
          margin-right: 4px;
        }

        /deep/ .ivu-input {
          height: 36px !important;
          border-radius: 18px !important;
          border: 1px solid $iv-main-color;
          background: none;
          padding: 0 16px;
        }
      }

      .ivu-btn {
        width: 72px;
      }
    }
  }
}

.ivu-btn-primary {
  color: #fff !important;
  background-color: $iv-main-color !important;
  height: 36px;

  &:hover {
    color: #fff !important;
  }
}
</style>